import axios, { getServerErrorMessage } from '../utils/axios'
import * as c from '../constants/UserConstants'
import { DEFAULT_REQUEST_ERROR } from '../constants/MessageConstants'

export const logoutUser = () => async dispatch => {
  dispatch({ type: c.LOGOUT_USER })
  await axios.post(`${Config.API_URL}/on-logout`, {})
}
export const loginUser = () => ({ type: c.LOGIN_USER_FULFILLED })
export const loggingInUser = () => ({ type: c.LOGIN_USER_PENDING })

export const fetchUserDetails = () => async dispatch => {
  dispatch({ type: c.FETCH_USER_DETAILS_PENDING })

  try {
    dispatch(logoutUser())
    const { data } = await axios.get(`${Config.API_URL}/mydetails?app=som`)
    const adminRole = data.roles.find(r => r.role === 'E')

    if (adminRole) {
      dispatch({
        type: c.FETCH_USER_DETAILS_FULFILLED,
        payload: { ...data, selectedOrgId: adminRole.orgId },
      })
    } else {
      dispatch({ type: c.FETCH_USER_DETAILS_DENIED })
    }
  } catch (err) {
    dispatch({
      type: c.FETCH_USER_DETAILS_REJECTED,
      payload: getServerErrorMessage(err || DEFAULT_REQUEST_ERROR),
    })
  }
}
